import { EMPTY_STRING } from '../../../../constants/common'
import { DATE_DAY_MONTH_SHORT_FORMAT } from '../../../../constants/date'
import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../constants/rentalPortal'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../constants/route'
import {
  APPLICANTS_FILTER_PARAM,
  getApplicantProfileDecisionLink,
  getApplicantProfileLink,
} from '../../../RentalPortalApplicant'
import { formatDate } from '../../../Table'
import { getRentalPortalSubsectionLink } from '../../RentalPortal.utils'
import { LISTINGS_FILTER_TOGGLE_VALUE } from '../../RentalPortalListings'

export function getOverviewApprovalProfileLink(row) {
  return getApplicantProfileLink(row.applicant_id)
}

export function getOverviewApprovalDecisionLink(row) {
  return getApplicantProfileDecisionLink(row.applicant_id)
}

export function getCanApproveOverviewApprovalRow(row) {
  return Boolean(row.can_approve)
}

export function getOverviewApprovalSelectedFact({ locale, row, t, timezone }) {
  return row.selected_at
    ? `${RENTAL_PORTAL_FACT_SEPARATOR}${t(
        'RentalPortal.OverviewApprovalSelectedOnKey',
        {
          date: formatDate({
            date: row.selected_at,
            dateFormat: DATE_DAY_MONTH_SHORT_FORMAT,
            locale,
            timezone,
            useTodayFormat: false,
          }),
        }
      )}`
    : EMPTY_STRING
}

export function getOverviewApprovalShowAllLink() {
  return `${getRentalPortalSubsectionLink(ROUTE_PATH_LIST_RENTAL_PORTAL.applicants)}?${APPLICANTS_FILTER_PARAM.awaitingMyApproval}=${LISTINGS_FILTER_TOGGLE_VALUE}`
}
